import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PlatformLocation} from '@angular/common';
import { CommonService } from "../common.service";

@Component({
  selector: 'app-error',
  templateUrl: './app-error.component.html',
  styleUrls: ['./app-error.component.css']
})
export class AppErrorComponent implements OnInit, AfterViewInit {

  errorStatus: any;
  notFind: boolean = false;
  otherError: boolean = false;
  loadError: boolean = false;
  accessError: boolean = false;
  assetsRoute: string = "../../assets";

  constructor(private route: ActivatedRoute,
              private router: Router,
              private commonService: CommonService,
              private platformLocation: PlatformLocation) {}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    document.documentElement.style.backgroundColor = '#F6F7FC';
    this.route.params.subscribe(params => {
      this.errorStatus = params['status'];
      if(this.errorStatus === '404'){
        this.notFind = true;
        this.loadError = false;
        this.otherError = false;
      }else if(this.errorStatus === '500'){
        this.notFind = false;
        this.loadError = true;
        this.otherError = false;
      }else if(this.errorStatus === 'permissionDenied'){
        this.notFind = false;
        this.loadError = false;
        this.otherError = false;
        this.accessError = true;
      }else{
        this.notFind = false;
        this.loadError = false;
        this.otherError = true;
      }
    });

  }

  ngAfterViewInit(){
    this.commonService.initPage({
      'backgroundColor':'#F6F7FC'
    });
  }

  refresh() {
    // this._location.back();
    window.history.go(-2);
  }

  goHome(){
    this.platformLocation["location"]["href"] =this.platformLocation["location"]["origin"]+"/ddilearner/v1/user/authorize"+`?token=${localStorage.getItem('transtalen-token')}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/app-error/app-error.component.ts